import ViewSetupPiece from "./ViewSetupPiece";

export default ViewSetupPiece;
